import { isAfter } from "date-fns/isAfter";
import { parse } from "date-fns/parse";

import { CustomSuggestion, PosProduct, TopUpSuggestion } from "../types/posProduct";
import { AvailabilityStatus, Product, ProductListRes } from "../types/product";
import { get, post } from "./fetch.core";

export async function loadProducts(
  params: Partial<any> & { includeVariationChildren?: boolean },
) {
  const filter: any = {};

  if (params.search) {
    filter.search = params.search;
  }

  filter.paging = params.paging;

  if (params.includeVariationChildren === true) {
    filter.includeVariationChildren = true;
  }

  if (params.catSlug) {
    filter.cats = {
      slugs: [params.catSlug],
      type: "and",
    };
  }
  const res = await post<ProductListRes>("/pos/product/list", filter);
  return res.data;
}

export async function getPosProducts() {
  const res = await post<ProductListRes>("/pos/product/list", {});
  return res.data;
}

export async function getPosProduct(productId: string, code?: string): Promise<Product> {
  const res = await get<PosProduct>(`/pos/product/get?productId=${productId}&code=${code ?? ""}`);
  return res.data;
}

export async function getPosProductByCode(code: string): Promise<Product> {
  const res = await get<PosProduct>(`/pos/product/get?code=${code}`, {}, true);
  return res.data;
}

export async function getPosProductVariations(parentId: string): Promise<Product[]> {
  const res = await get<PosProduct[]>(`/pos/product/listVariations?parentId=${parentId}`);
  return res.data;
}

export async function autoCompleteProduct(search: string) {
  const res = await post<ProductListRes>("/pos/product/list", { search });
  return res.data;
}

export async function getCustomSuggestions(productId: string) {
  const res = await get<CustomSuggestion[]>(`/pos/product/getCustomSuggestions?productId=${productId}`);
  return res.data;
}

export async function getTopUpSuggestions(productId: string) {
  const res = await get<TopUpSuggestion[]>(`/pos/product/getTopUpSuggestions?productId=${productId}`);
  return res.data;
}

function hasStockReadyDateAndNotAfter(product: Product) {
  if (!product.stockReadyDate) return false;
  return isAfter(getStockReadyDate(product), new Date());
}

function getStockReadyDate(product: Product) {
  return parse(product.stockReadyDate, "yyyy-MM-dd", new Date());
}

function getAvailabilityStatus(product: Product): AvailabilityStatus {
  if (product.availability === "in" || !product.availability) {
    return {
      availability: "in",
      canOrder: true,
    };
  }

  if (product.availability === "out" && hasStockReadyDateAndNotAfter(product)) {
    return {
      availability: product.availability,
      canOrder: true,
      stockReadyDate: getStockReadyDate(product),
    };
  }

  return {
    availability: "out",
    canOrder: false,
  };
}

const posProductCore = {
  getAvailabilityStatus,
  getCustomSuggestions,
  getPosProduct,
  getPosProducts,
  getTopUpSuggestions,
};

export default posProductCore;
